import { SocialExportContext } from '@app/modules/social-export/components/dialogs/social-export-context';
import { Box, FormHelperText, FormLabel } from '@mui/material';
import { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { FrameSelector } from '../frame-selector/FragmentFrameSelector';

export function FrameSelectorFieldMui({
  name,
  unit = 'seconds',
  children,
  videoUrl,
}: {
  name: string;
  unit?: 'seconds' | 'ms';
  children?: React.ReactNode;
  videoUrl?: string;
}) {
  const { $t } = useIntl();
  const { control } = useFormContext();
  const { mediaUrl } = useContext(SocialExportContext);

  return (
    <Box>
      <FormLabel>
        {$t({
          id: 'form.frameThumbnailLabel',
          defaultMessage: 'Frame a utilizar como thumbnail',
        })}
      </FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <FrameSelector
              time={value}
              onSelect={(time) => {
                onChange(time !== null ? (unit === 'seconds' ? time / 1000 : time) : null);
              }}
              unit={unit}
              children={children}
              src={videoUrl ?? mediaUrl}
            />
            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        )}
      />
    </Box>
  );
}
